import React from 'react';

import { TableCard, Box, Divider } from 'vindi-ds-components';
import tagChipPaymentStatus from '../utils/tag_chip_payment_status';
import EmptyStateCharges from './empty_state';

const TableCardCharges = ({ charges }) => {
  if (charges.length === 0) {
    return <EmptyStateCharges />;
  }

  return (
    <Box display='flex' flexDirection='column' gridGap='24px' mb={2}>
      {charges?.map((charge) => (
        <TableCard.Container key={charge.id}>
          <TableCard.Text label='ID' value={charge.id} url='#' />

          <Divider />

          <TableCard.TextWithSub label='Cliente' value={charge.customer.name} subtitle={charge.customer.id} />

          <TableCard.TextWithSub label='Value' value={charge.value} subtitle={charge.payment_method_name} />

          <TableCard.Text label='Emissão' value={charge.emission} />

          <TableCard.Text label='Vencimento' value={charge.due_date} />

          <TableCard.Text label='Pagamento' value={charge.date_payment} />

          <TableCard.TextWithTagChip
            label='Status do pagamento'
            value={charge.status}
            kind={tagChipPaymentStatus(charge.status)}
          />

        </TableCard.Container>
      ))}
    </Box>
  );
};

export default TableCardCharges;
